// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const transactionApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    getAllTransaction: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `transaction?${queryString}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllTransactionQuery } = transactionApi;
